import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  cityValidator,
  countryValidator,
  dateValidatorRequired,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  radioValidator,
  textareaValidatorRequired,
  timeValidatorRequired,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_CIRCUMSTANCES]: yup.object({
    [ComponentId.CIRCUMSTANCES_DATE]: dateValidatorRequired,
    [ComponentId.CIRCUMSTANCES_HOUR]: timeValidatorRequired,
    [ComponentId.CIRCUMSTANCES_PLACE]: textareaValidatorRequired(250),
    [ComponentId.CIRCUMSTANCES_ZIP_CODE_PL]: postalCodePolandValidator,
    [ComponentId.CIRCUMSTANCES_ZIP_CODE_GENERIC]: postalCodeGenericValidator,
    [ComponentId.CIRCUMSTANCES_CITY]: cityValidator,
    [ComponentId.CIRCUMSTANCES_COUNTRY]: countryValidator,
    [ComponentId.CIRCUMSTANCES_PROVINCE]: provinceValidator,
    [ComponentId.CIRCUMSTANCES_WAS_VEHICLE_IN_MOTION]: radioValidator,
    [ComponentId.CIRCUMSTANCES_DESCRIPTION]: trimmedString.onlyIfFieldIsVisible(
      textareaValidatorRequired(2000)
    ),
    [ComponentId.CIRCUMSTANCES_WAS_DRIVER]:
      trimmedString.onlyIfFieldIsVisible(radioValidator),
  }),
};
